(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class FaubourgAnnouncementBar extends HTMLElement {
    connectedCallback() {
      // What the bar takes from the first screen, for a surface that has to
      // end at its foot: the setting until measured, the real height once a
      // line wraps, and nothing once the shopper has dismissed it.
      if (typeof ResizeObserver === 'function') {
        this.heightObserver = new ResizeObserver(this.publishHeight);
        this.heightObserver.observe(this);
      }

      this.dismissButton = this.querySelector('[data-announcement-dismiss]');

      if (this.dismissButton) {
        // The merchant is shown the bar they are editing, whatever they
        // dismissed while previewing the storefront.
        if (!window.Shopify?.designMode && this.readDismissed()) {
          this.hidden = true;
          return;
        }
        this.dismissButton.hidden = false;
        this.dismissButton.addEventListener('click', this.onDismiss);
      }

      this.items = [...this.querySelectorAll('[data-announcement-item]')];
      if (this.items.length < 2) return;

      // Served reachable, for a page with no script to move them; from here
      // only the message on the screen is. A bar the editor reconnects keeps
      // the one it was showing.
      this.current = Math.max(this.items.findIndex((item) => item.classList.contains('is-current')), 0);
      this.items.forEach((item, index) => {
        item.classList.toggle('is-current', index === this.current);
        if (index === this.current) item.removeAttribute('inert');
        else item.setAttribute('inert', '');
      });
      this.setAttribute('data-enhanced', '');
      this.navButtons = [...this.querySelectorAll('[data-announcement-step]')];
      for (const button of this.navButtons) {
        button.hidden = false;
        button.addEventListener('click', this.onStep);
      }

      this.toggle = this.querySelector('[data-announcement-toggle]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (this.toggle && !this.reduced.matches) {
        this.toggle.hidden = false;
        this.toggle.addEventListener('click', this.onToggle);
      }

      this.paused = false;
      this.start();

      this.addEventListener('pointerenter', this.stop);
      this.addEventListener('pointerleave', this.start);
      this.addEventListener('focusin', this.stop);
      this.addEventListener('focusout', this.start);

      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.stop();
      this.heightObserver?.disconnect();
      // Moved or redrawn, a bar is back by the end of this task and publishes
      // its own height; gone for good, what it reserved goes with it.
      queueMicrotask(() => {
        if (!document.querySelector('faubourg-announcement-bar')) {
          document.documentElement.style.removeProperty('--announcement-bar-height');
        }
      });
      this.dismissButton?.removeEventListener('click', this.onDismiss);
      this.toggle?.removeEventListener('click', this.onToggle);
      for (const button of this.navButtons || []) button.removeEventListener('click', this.onStep);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    publishHeight = () => {
      const height = this.hidden ? 0 : this.offsetHeight;
      document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
    };

    get storageKey() {
      return `faubourg:announcement-dismissed:${this.dataset.announcementKey || 'default'}`;
    }

    get motionDuration() {
      const declared = getComputedStyle(this).getPropertyValue('--motion-base');
      return parseFloat(declared) || 0;
    }

    readDismissed() {
      try {
        return window.localStorage.getItem(this.storageKey) === '1';
      } catch {
        return false;
      }
    }

    onDismiss = () => {
      try {
        window.localStorage.setItem(this.storageKey, '1');
      } catch {
        /* Without storage the dismissal holds for this page view only. */
      }

      this.stop();

      this.style.setProperty('--bar-collapse', `${this.offsetHeight}px`);
      this.setAttribute('data-dismissing', '');
      window.setTimeout(this.finishDismiss, this.motionDuration);
    };

    finishDismiss = () => {
      // The cross that was pressed is about to leave with the bar: the focus
      // goes on to what follows it rather than to the top of the page.
      if (this.contains(document.activeElement)) {
        const reachable = 'a[href], button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"])';
        const next = [...document.querySelectorAll(reachable)].find(
          (control) =>
            !this.contains(control) &&
            this.compareDocumentPosition(control) & Node.DOCUMENT_POSITION_FOLLOWING &&
            control.getClientRects().length > 0 &&
            !control.closest('[inert], [hidden]')
        );
        next?.focus();
      }

      this.hidden = true;
      this.removeAttribute('data-dismissing');
      this.style.removeProperty('--bar-collapse');
    };

    get interval() {
      return Number(this.dataset.autoplay || 0) * 1000;
    }

    onToggle = () => {
      this.paused = !this.paused;
      const { labelPause, labelPlay } = this.toggle.dataset;
      this.toggle.setAttribute('aria-label', this.paused ? labelPlay : labelPause);
      this.toggle.toggleAttribute('data-paused', this.paused);
      if (this.paused) {
        this.stop();
      } else {
        this.start();
      }
    };

    start = () => {
      this.stop();
      if (this.paused || !this.interval || this.reduced?.matches) return;
      this.timer = setInterval(() => this.step(1), this.interval);
      this.announceSteps();
    };

    stop = () => {
      clearInterval(this.timer);
      this.timer = null;
      this.announceSteps();
    };

    // A slide that changes by itself is not announced over what the shopper is
    // reading; one they step to is.
    announceSteps() {
      this.querySelector('.announcement-bar__track[aria-live]')?.setAttribute('aria-live', this.timer ? 'off' : 'polite');
    }

    onStep = (event) => {
      const button = event.currentTarget || event.target;
      this.step(Number(button.dataset.announcementStep));
    };

    onBlockSelect = (event) => {
      const at = this.items.indexOf(event.target);
      if (at === -1) return;
      this.stop();
      this.show(at, at > this.current ? 'next' : 'prev');
    };

    step(delta) {
      const total = this.items.length;
      this.show((this.current + delta + total) % total, delta < 0 ? 'prev' : 'next');
    }

    show(next, direction) {
      if (next === this.current) return;

      const leaving = this.items[this.current];
      const entering = this.items[next];

      leaving.classList.remove('is-current');
      leaving.classList.add('is-leaving');
      leaving.setAttribute('inert', '');

      // Muted while the resting offset flips with the direction, or the
      // incoming slide travels the whole way across before it begins.
      entering.style.transition = 'none';
      entering.classList.remove('is-leaving');
      this.dataset.direction = direction;
      void entering.offsetWidth;
      entering.style.transition = '';

      entering.classList.add('is-current');
      entering.removeAttribute('inert');

      this.current = next;
    }
  }

  if (!customElements.get('faubourg-announcement-bar')) {
    customElements.define('faubourg-announcement-bar', FaubourgAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  /*
   * The drawer surface, registered as the page loads rather than with the cart
   * module above. Opening the drawer needs nothing but the drawer primitive and
   * the cart Shopify already rendered into it, and it is registering the element
   * that swaps the header's `/cart` link for its drawer trigger. Left to the
   * lazy import, that swap happened only after the shopper had already
   * interacted -- so the first click on the cart icon, on every page load, spent
   * itself on a navigation the shopper had not asked for.
   *
   * No Drawer means no registration: the trigger stays hidden, the link stays
   * visible, and `/cart` remains the operable path.
   */
  (function () {
    var Drawer = window.Faubourg && window.Faubourg.Drawer;
    if (!Drawer) return;
    if (customElements.get('faubourg-cart-drawer')) return;

    class CartDrawer extends Drawer {}
    customElements.define('faubourg-cart-drawer', CartDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('faubourg-header')) {
    customElements.define(
      'faubourg-header',
      class FaubourgHeader extends HTMLElement {
        // The header leaves on distance the page has travelled one way, not on
        // the few pixels a trackpad drifts by: it goes after a deliberate move
        // down, and comes back sooner, for a shopper looking for it.
        static HIDE_AFTER = 32;

        static SHOW_AFTER = 12;

        static HOVER_OPEN_DELAY = 90;

        static HOVER_CLOSE_DELAY = 220;

        static NAV_ROW_TOLERANCE = 1;

        static EDITOR_EVENTS = ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'];

        connectedCallback() {
          this.desktop = window.matchMedia('(min-width: 990px)');
          this.finePointer = window.matchMedia('(pointer: fine)');
          this.height = this.offsetHeight;
          this.lastScroll = Math.max(window.scrollY, 0);
          this.lastHeight = document.documentElement.scrollHeight;
          this.keptPlace = 0;
          this.jumped = false;
          this.travelled = 0;
          this.ticking = false;

          this.navRestoreAt = 0;

          this.hoverTimer = null;

          this.addEventListener('click', this.handlePress, true);
          this.addEventListener('pointerover', this.handlePrime);
          this.addEventListener('toggle', this.handleToggle, true);
          this.addEventListener('keydown', this.handleKeydown);
          this.addEventListener('focusin', this.handleFocusin);
          this.addEventListener('focusout', this.handleFocusout);
          this.desktop.addEventListener('change', this.handleBreakpoint);
          document.addEventListener('click', this.handleDocumentClick);
          document.addEventListener('click', this.handleJump);
          window.addEventListener('hashchange', this.handleJump);

          document.addEventListener('drawer:open', this.handleDrawerState);
          document.addEventListener('drawer:close', this.handleDrawerState);
          document.addEventListener('page:kept-place', this.handleKeptPlace);

          this.resizeObserver = new ResizeObserver(this.handleResize);
          this.resizeObserver.observe(this);

          for (const type of FaubourgHeader.EDITOR_EVENTS) document.addEventListener(type, this.handleEditor);
          document.addEventListener('shopify:block:select', this.handleBlockSelect);
          document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

          if (this.dataset.sticky !== 'none') {
            window.addEventListener('scroll', this.handleScroll, { passive: true });
            // A page restored halfway down is put in the state of where it
            // stands, not of where it was loaded from. The browser may have put
            // it there before this script ran, or put it there after, which the
            // header hears as a scroll from the top: either way it is taken as
            // one.
            this.lastScroll = 0;
            this.updateScrollState();
          }

          if (this.dataset.menuOpenOn === 'hover') {
            this.addEventListener('pointerover', this.handlePointerOver);
            this.addEventListener('pointerleave', this.handlePointerLeave);
          }
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handlePress, true);
          this.removeEventListener('pointerover', this.handlePrime);
          this.removeEventListener('toggle', this.handleToggle, true);
          this.removeEventListener('keydown', this.handleKeydown);
          this.removeEventListener('focusin', this.handleFocusin);
          this.removeEventListener('focusout', this.handleFocusout);
          this.desktop.removeEventListener('change', this.handleBreakpoint);
          document.removeEventListener('click', this.handleDocumentClick);
          document.removeEventListener('click', this.handleJump);
          window.removeEventListener('hashchange', this.handleJump);
          document.removeEventListener('drawer:open', this.handleDrawerState);
          document.removeEventListener('drawer:close', this.handleDrawerState);
          document.removeEventListener('page:kept-place', this.handleKeptPlace);
          for (const type of FaubourgHeader.EDITOR_EVENTS) document.removeEventListener(type, this.handleEditor);
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
          window.removeEventListener('scroll', this.handleScroll);
          cancelAnimationFrame(this.dressingFrame);
          this.resizeObserver.disconnect();
          this.removeEventListener('pointerover', this.handlePointerOver);
          this.removeEventListener('pointerleave', this.handlePointerLeave);
          this.cancelHover();
        }

        // The editor adds, removes and moves sections without reconnecting the
        // header: its height and the state of where the page stands are taken
        // again.
        handleEditor = () => {
          this.handleResize();
          if (this.dataset.sticky !== 'none') this.updateScrollState();
        };

        // A promotion lives in a closed panel, so selecting its block shows the
        // merchant nothing unless the panel that holds it is opened. The block
        // is drawn once for each place a menu is drawn, all under one id.
        handleBlockSelect = (event) => {
          const id = event.detail && event.detail.blockId;
          const promos = Array.from(document.querySelectorAll('.menu-promo[data-shopify-editor-block]')).filter((promo) => {
            try {
              return JSON.parse(promo.dataset.shopifyEditorBlock).id === id;
            } catch {
              return false;
            }
          });
          if (promos.length === 0) return;

          this.handleBlockDeselect();
          this.callBack();
          this.travelled = 0;

          const details = promos.map((promo) => promo.closest('.header-menu__details')).find((panel) => panel && panel.getClientRects().length > 0);
          if (details) {
            this.closeAll(details);
            this.holdInk();
            details.open = true;
            this.revealed = details;
            return;
          }

          const drawer = document.getElementById('menu-drawer');
          const promo = promos.find((candidate) => drawer && drawer.contains(candidate));
          if (promo && drawer.reveal(promo)) this.revealed = drawer;
        };

        handleBlockDeselect = () => {
          const revealed = this.revealed;
          this.revealed = null;
          if (!revealed) return;

          if (revealed instanceof HTMLDetailsElement) {
            this.holdInk();
            revealed.open = false;
          } else {
            revealed.close({ returnFocus: false, reason: 'editor' });
          }
        };

        get disclosures() {
          return Array.from(this.querySelectorAll('details'));
        }

        get hasOpenDisclosure() {
          return this.disclosures.some((details) => details.open);
        }

        closeAll(except, scope = this.disclosures) {
          this.cancelHover();

          for (const details of scope) {
            if (details === except) continue;
            if (except && details.contains(except)) continue;
            if (!details.open) continue;
            this.holdInk();
            details.open = false;
          }
        }

        // Taken before anything the header opens or closes changes its dress,
        // for the one frame in which it does (see `data-dressing`).
        holdInk() {
          this.dataset.dressing = '';
          cancelAnimationFrame(this.dressingFrame);
          this.dressingFrame = requestAnimationFrame(() => {
            this.dressingFrame = requestAnimationFrame(() => {
              delete this.dataset.dressing;
            });
          });
        }

        // A press on a summary opens or closes it as its default action, after
        // this listener: the ink is held first, so the panel and the bar's new
        // dress arrive in the same frame.
        //
        // A pointer that rested on a menu has already opened it, and the press
        // that follows is the same intent arriving a moment later: it used to
        // close the panel the hover had just opened. The keyboard's press
        // (`detail` 0) still toggles.
        handlePress = (event) => {
          if (event.target instanceof Element && event.target.closest('.header__veil')) {
            this.closeAll();
            return;
          }

          const summary = event.target instanceof Element && event.target.closest('summary');
          if (!summary) return;

          const details = summary.parentElement;
          if (event.detail > 0 && details.open && details.dataset.openedBy === 'pointer') {
            delete details.dataset.openedBy;
            event.preventDefault();
            return;
          }

          this.holdInk();
        };

        // What a pointer opened, a pointer may close: hover is the menu's own
        // way of opening, so leaving it closes the menu and nothing else. The
        // localization selector is opened by a press and waits for one -- it
        // used to close the moment the pointer crossed from its toggle onto
        // its own panel, because that crossing counted as leaving the menu.
        closeMenus() {
          this.closeAll(null, this.querySelectorAll('.header-menu__details'));
        }

        handleResize = () => {
          this.measureNavFit();
          this.height = this.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.height}px`);
        };

        measureNavFit() {
          const list = this.querySelector('.header__nav .header-menu__list');
          if (!list || !this.desktop.matches) return;

          if (this.classList.contains('header--nav-overflow')) {
            if (window.innerWidth < this.navRestoreAt) return;
            this.classList.remove('header--nav-overflow');
          }

          const items = Array.from(list.children);
          if (items.length === 0) return;

          const top = items[0].getBoundingClientRect().top;
          const wrapped = items.some((item) => item.getBoundingClientRect().top - top > FaubourgHeader.NAV_ROW_TOLERANCE);

          if (!wrapped) {
            this.navRestoreAt = 0;
            return;
          }

          const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
          const wanted = items.reduce(
            (total, item) => total + item.getBoundingClientRect().width,
            gap * (items.length - 1)
          );
          const short = Math.max(wanted - list.getBoundingClientRect().width, 1);

          const share = this.classList.contains('header--logo-center') ? 2 : 1;
          this.navRestoreAt = window.innerWidth + short * share + 1;
          this.classList.add('header--nav-overflow');
        }

        navHandsOff() {
          this.measureNavFit();
          return this.classList.contains('header--nav-overflow');
        }

        handleKeptPlace = (event) => {
          this.keptPlace += event.detail?.top || 0;
        };

        // A link to a place on this page (see `updateScrollState`): put away
        // on the way down, the header left a gap above the place. A hidden
        // header is called back before the browser follows the link, so the
        // browser keeps its clearance; a jump it learns of only afterwards
        // (`hashchange`) leaves it hidden.
        handleJump = (event) => {
          if (event.type === 'click') {
            const link = event.target instanceof Element ? event.target.closest('a[href*="#"]') : null;
            if (event.defaultPrevented || !link || link.origin !== location.origin || link.pathname !== location.pathname || !link.hash) return;
            this.callBack();
          }
          this.jumped = true;
        };

        handleScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.updateScrollState();
          });
        };

        // Where the page stands decides the state; which way it last moved
        // decides between pinned and hidden. See the states in the stylesheet.
        updateScrollState() {
          const current = Math.max(window.scrollY, 0);
          // A script that scrolled to keep the shopper's place said by how
          // much; that part of the move is not theirs.
          const delta = current - this.lastScroll - this.keptPlace;
          this.lastScroll = current;
          this.keptPlace = 0;

          // What the page adds or takes away above the screen moves it by as
          // much while nothing the shopper sees moves: the browser's scroll
          // anchoring holds their place. That is the page travelling, not the
          // shopper. Only a page that has changed height can travel: with
          // nothing grown, a pixel's move is a slow hand's.
          const height = document.documentElement.scrollHeight;
          const grown = height - this.lastHeight;
          this.lastHeight = height;
          const travelling = grown !== 0 && delta !== 0 && Math.abs(delta - grown) <= 1;

          // At its place, where the pinned header and the header at rest
          // stand in the same spot.
          const place = this.place;
          if (current <= place) {
            this.travelled = 0;
            this.setState('rest');
            return;
          }

          // A link to a place on the page: the browser scrolled to it with the
          // header's clearance as it stood, so until the shopper scrolls the
          // header is pinned if it was on the screen, and stays away if it was
          // hidden: there was no clearance, and coming back would cover the
          // place.
          if (this.jumped) {
            this.jumped = false;
            this.travelled = 0;
            if (this.dataset.stickyState !== 'hidden') this.setState('pinned');
            return;
          }

          if (this.dataset.sticky === 'always') {
            this.setState('pinned');
            return;
          }

          // Hiding on the way down: while any of the header's place is on the
          // screen, the header is there, at rest, scrolling with the page.
          const state = this.dataset.stickyState;
          const placeInView = current < place + this.height;
          if (placeInView && state !== 'pinned') {
            this.travelled = 0;
            this.setState('rest');
            return;
          }
          // Its place gone above the screen, a header at rest is put away
          // where it cannot be seen.
          if (state !== 'pinned' && state !== 'hidden') {
            this.travelled = 0;
            this.setState('hidden');
            return;
          }
          if (travelling || delta === 0) return;

          // Distance in one direction, counted again whenever the page turns.
          if (Math.sign(delta) !== Math.sign(this.travelled)) this.travelled = 0;
          this.travelled += delta;

          if (this.travelled >= FaubourgHeader.HIDE_AFTER) {
            // Held, the header lets the distance go: once the shopper is done
            // with it, leaving takes a fresh deliberate scroll, not a nudge.
            if (this.holdsPlace) this.travelled = 0;
            else this.setState('hidden');
          } else if (this.travelled <= -FaubourgHeader.SHOW_AFTER) {
            this.setState('pinned');
          }
        }

        // The scroll at which the header's place, under the announcement bar,
        // reaches the top of the screen.
        get place() {
          const root = getComputedStyle(document.documentElement);
          return parseFloat(root.getPropertyValue('--announcement-bar-height')) || 0;
        }

        // Only a header pinned at the top of the screen travels: out on the
        // way down and back in on the way up. Every other change is made in one
        // frame, in place or off the screen. A change of dress holds the ink
        // for that frame (`data-dressing`).
        setState(next) {
          const previous = this.dataset.stickyState;
          if (previous === next) return;
          const slides = (previous === 'pinned' && next === 'hidden') || (previous === 'hidden' && next === 'pinned');
          this.toggleAttribute('data-sticky-slide', slides);
          // A slide under way is ended where it was going: taking its
          // transition away does not stop it when both states stand in the
          // same place.
          if (!slides) {
            for (const slide of this.closest('.shopify-section')?.getAnimations() ?? []) {
              if (slide.transitionProperty === 'transform') slide.finish();
            }
          }
          if (previous === 'rest' || next === 'rest') this.holdInk();
          this.dataset.stickyState = next;
        }

        // Called back by the keyboard, an open panel or the editor.
        callBack() {
          if (this.dataset.stickyState === 'hidden') this.setState('pinned');
        }

        // What a shopper is using stays: an open panel, or a control the
        // keyboard is on. Focus a drawer handed back after a pointer closed
        // it is not that, and used to pin the header for the rest of the page.
        get holdsPlace() {
          return this.hasOpenDisclosure || this.matches(':has(:focus-visible)');
        }

        handleToggle = (event) => {
          const details = event.target;
          if (!(details instanceof HTMLDetailsElement)) return;
          if (!details.open) delete details.dataset.openedBy;
          if (details.open) this.closeAll(details);
        };

        handleKeydown = (event) => {
          if (event.key !== 'Escape') return;

          const open = this.disclosures.filter((details) => details.open);
          if (open.length === 0) return;

          const innermost = open[open.length - 1];
          const summary = innermost.querySelector('summary');
          this.holdInk();
          innermost.open = false;
          if (summary) summary.focus();
        };

        handleDocumentClick = (event) => {
          if (this.contains(event.target)) return;
          this.closeAll();
        };

        handleBreakpoint = (event) => {
          if (!event.matches) return;
          this.closeAll();
        };

        // A panel belongs to the focus inside it. Keyboard focus that moves on --
        // to the next item, or out of the header -- closes what it left, as the
        // pointer leaving does, rather than leaving a panel over the content
        // the shopper went on to.
        handleFocusin = (event) => {
          this.callBack();
          this.travelled = 0;
          this.handlePrime(event);

          for (const details of this.disclosures) {
            if (!details.open || details.contains(event.target)) continue;
            this.holdInk();
            details.open = false;
          }
        };

        handleFocusout = (event) => {
          const next = event.relatedTarget;
          if (!(next instanceof Node) || this.contains(next)) return;
          this.closeAll();
        };

        cancelHover() {
          if (this.hoverTimer === null) return;
          clearTimeout(this.hoverTimer);
          this.hoverTimer = null;
        }

        scheduleHover(delay, action) {
          this.cancelHover();
          this.hoverTimer = setTimeout(() => {
            this.hoverTimer = null;
            action();
          }, delay);
        }

        // A panel's pictures wait, lazily, for the panel to open, and then
        // arrive a moment after it. The pointer or the keyboard reaching its
        // summary already says it is about to: they are sent for then. A
        // shopper who never goes near the menu fetches none of them.
        primePictures(details) {
          if (!details || details.dataset.primed) return;
          details.dataset.primed = '';
          for (const image of details.querySelectorAll('img[loading="lazy"]')) image.loading = 'eager';
        }

        handlePrime = (event) => {
          if (event.target instanceof Element) this.primePictures(event.target.closest('.header-menu__details'));
        };

        handlePointerOver = (event) => {
          if (!this.finePointer.matches || !this.desktop.matches) return;

          const details = event.target.closest('.header-menu__details');

          if (!details) {
            this.scheduleHover(FaubourgHeader.HOVER_CLOSE_DELAY, () => this.closeMenus());
            return;
          }

          if (details.open) {
            this.cancelHover();
            return;
          }

          this.scheduleHover(FaubourgHeader.HOVER_OPEN_DELAY, () => {
            this.closeAll(details);
            this.holdInk();
            details.dataset.openedBy = 'pointer';
            details.open = true;
          });
        };

        handlePointerLeave = () => {
          if (!this.finePointer.matches || !this.desktop.matches) return;
          this.scheduleHover(FaubourgHeader.HOVER_CLOSE_DELAY, () => this.closeMenus());
        };

        handleDrawerState = (event) => {
          const id = event.detail && event.detail.id;
          if (id !== 'menu-drawer') return;
          this.holdInk();
          this.classList.toggle('header--menu-open', event.type === 'drawer:open');
        };
      }
    );
  }

  (function () {
    var Drawer = window.Faubourg && window.Faubourg.Drawer;
    if (!Drawer) return;

    var DESKTOP = '(min-width: 990px)';

    class MenuDrawer extends Drawer {
      #desktop = null;

      #nav = null;
      #track = null;
      #panels = [];
      #chain = [];
      #triggerByPanel = new WeakMap();
      #titleByPanel = new WeakMap();
      #localization = null;

      #onBreakpoint = (event) => {
        if (!event.matches) return;

        if (this.classList.contains('drawer--persistent')) return;

        const header = document.querySelector('.header');
        if (header && typeof header.navHandsOff === 'function' && header.navHandsOff()) return;

        const wasFocused = this.contains(document.activeElement);

        this.close({ returnFocus: false, reason: 'breakpoint' });

        if (!wasFocused) return;

        const landings = [
          document.querySelector('.header__nav'),
          document.querySelector('.header__utilities'),
          document.querySelector('.header__logo'),
        ];

        for (const landing of landings) {
          if (Drawer.focusFirst(landing)) return;
        }
      };

      #onPanelKeydown = (event) => {
        if (event.key !== 'Escape') return;
        if (this.#chain.length <= 1) return;

        event.stopPropagation();
        event.preventDefault();
        this.#drillBack();
      };

      connectedCallback() {
        super.connectedCallback();

        this.#desktop = window.matchMedia(DESKTOP);
        this.#desktop.addEventListener('change', this.#onBreakpoint);

        this.#buildPanels();
        this.addEventListener('keydown', this.#onPanelKeydown);
      }

      disconnectedCallback() {
        if (this.#desktop) {
          this.#desktop.removeEventListener('change', this.#onBreakpoint);
          this.#desktop = null;
        }

        this.removeEventListener('keydown', this.#onPanelKeydown);

        super.disconnectedCallback();
      }

      open(options) {
        const opened = super.open(options);
        if (opened) this.#resetPanels();
        return opened;
      }

      close(options) {
        const closed = super.close(options);
        if (closed) this.#resetPanels();
        return closed;
      }

      // Opens on the panel holding `element`, for the editor to show a block
      // that sits a drill deep.
      reveal(element) {
        const panel = element.closest('[data-menu-panel]');
        if (!panel || !this.#panels.includes(panel)) return false;

        // Already open on another panel, the drawer is not reopened, so it is
        // not reset either: the panel is reached from the root, not from there.
        const wasOpen = this.isOpen;
        this.open({ reason: 'editor' });
        if (wasOpen && this.#chain[this.#chain.length - 1] !== panel) this.#resetPanels();
        if (this.#chain.includes(panel)) return true;

        this.#chain.push(panel);
        this.#syncPanels();
        this.#triggerByPanel.get(panel)?.setAttribute('aria-expanded', 'true');
        this.#writeTrail();
        return true;
      }

      #buildPanels() {
        const nav = this.querySelector('.menu-nav');
        if (!nav) return;

        const list = nav.querySelector(':scope > .menu-nav__list');
        if (!list) return;

        this.#localization = this.querySelector('.menu-nav__localization');

        const track = document.createElement('div');
        track.className = 'menu-nav__track';
        nav.insertBefore(track, list);
        track.appendChild(list);

        this.#nav = nav;
        this.#track = track;
        this.#panels = [list];

        const detailsList = Array.prototype.slice.call(list.querySelectorAll('details.menu-nav__details'));
        detailsList.forEach((details) => this.#convertDetails(details, track));

        this.querySelector('[data-drawer-back]')?.addEventListener('click', () => this.#drillBack());

        nav.classList.add('menu-nav--paneled');
        this.#chain = [list];
        this.#syncPanels();
      }

      #convertDetails(details, track) {
        const summary = details.querySelector(':scope > summary.menu-nav__summary');
        const panel = details.querySelector(':scope > .menu-nav__panel');
        if (!summary || !panel) return;

        track.appendChild(panel);
        this.#panels.push(panel);

        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = summary.className;
        trigger.innerHTML = summary.innerHTML;
        panel.id ||= `${this.id || 'menu'}-panel-${this.#panels.length}`;
        trigger.setAttribute('aria-controls', panel.id);
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', () => this.#drillInto(panel));

        this.#triggerByPanel.set(panel, trigger);
        this.#titleByPanel.set(panel, summary.textContent.trim());
        details.replaceWith(trigger);
      }

      #drillInto(panel) {
        this.#chain.push(panel);
        this.#syncPanels();

        const trigger = this.#triggerByPanel.get(panel);
        if (trigger) trigger.setAttribute('aria-expanded', 'true');

        this.#writeTrail()?.focus();
      }

      #drillBack() {
        if (this.#chain.length <= 1) return;

        const leaving = this.#chain.pop();
        this.#syncPanels();
        this.#writeTrail();

        const trigger = this.#triggerByPanel.get(leaving);
        if (!trigger) return;

        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }

      #resetPanels() {
        if (this.#panels.length === 0) return;

        const root = this.#panels[0];
        if (this.#chain.length === 1 && this.#chain[0] === root) return;

        this.#panels.forEach((panel) => {
          const trigger = this.#triggerByPanel.get(panel);
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });

        this.#chain = [root];
        this.#writeTrail();
        this.#syncPanels({ instant: true });
      }

      #writeTrail() {
        const steps = this.#chain.slice(1).map((panel) => this.#titleByPanel.get(panel) || '');
        return window.Faubourg.overlayTrail(this, steps);
      }

      #syncPanels(options) {
        const settings = options || {};
        const activeIndex = this.#chain.length - 1;
        const active = this.#chain[activeIndex];

        const applyStates = () => {
          this.#panels.forEach((panel) => {
            const chainIndex = this.#chain.indexOf(panel);

            if (panel === active) {
              panel.dataset.panelState = 'active';
              panel.removeAttribute('inert');
            } else if (chainIndex !== -1) {
              panel.dataset.panelState = 'prev';
              panel.setAttribute('inert', '');
            } else {
              panel.dataset.panelState = 'next';
              panel.setAttribute('inert', '');
            }
          });

          if (!this.#localization) return;
          if (activeIndex > 0) this.#localization.setAttribute('inert', '');
          else this.#localization.removeAttribute('inert');
        };

        if (!settings.instant || !this.#nav) {
          applyStates();
          return;
        }

        this.#nav.classList.add('menu-nav--instant');
        applyStates();
        this.#nav.offsetHeight;
        this.#nav.classList.remove('menu-nav--instant');
      }
    }

    if (!customElements.get('faubourg-menu-drawer')) {
      customElements.define('faubourg-menu-drawer', MenuDrawer);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class FaubourgHero extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.rail = this.querySelector('[data-hero-rail]');
      if (!this.rail) return;

      this.indices = [...this.rail.querySelectorAll('[data-hero-index]')];
      this.toggle = this.rail.querySelector('[data-hero-toggle]');
      // Where the band already stands: the editor reconnects a section it
      // re-renders, and the slide showing then need not be the first.
      this.current = Math.max(this.slides.findIndex((slide) => !slide.hidden), 0);
      this.visible = true;

      // Under reduced motion nothing here starts on its own; the shopper's
      // own press, remembered for the visit, outranks it either way.
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.readPaused() ?? this.reduced.matches;
      this.renderPaused();
      this.toggle?.addEventListener('click', this.onToggle);

      this.rail.hidden = false;
      this.rail.addEventListener('click', this.onClick);

      for (const film of this.querySelectorAll('[data-hero-video]')) {
        film.addEventListener('playing', () => film.setAttribute('data-playing', ''));
      }

      // A film plays only while its band is on the screen, and never before
      // the page has finished loading what it opened with.
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.syncFilm();
      });
      this.observer.observe(this);

      this.start();

      this.addEventListener('pointerenter', this.stop);
      this.addEventListener('pointerleave', this.start);
      this.addEventListener('focusin', this.stop);
      this.addEventListener('focusout', this.start);

      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.rail?.removeEventListener('click', this.onClick);
      this.toggle?.removeEventListener('click', this.onToggle);
    }

    get interval() {
      return Number(this.dataset.autoplay || 0) * 1000;
    }

    get storageKey() {
      return `faubourg:hero-paused:${this.dataset.heroKey || 'default'}`;
    }

    // The shopper's last press, or nothing where they have not pressed.
    readPaused() {
      try {
        const stored = window.sessionStorage.getItem(this.storageKey);
        return stored === null ? null : stored === '1';
      } catch {
        return null;
      }
    }

    writePaused(value) {
      try {
        window.sessionStorage.setItem(this.storageKey, value ? '1' : '0');
      } catch {}
    }

    renderPaused() {
      this.toggleAttribute('data-paused', this.paused);
      if (!this.toggle) return;
      for (const state of this.toggle.querySelectorAll('[data-hero-toggle-state]')) {
        state.toggleAttribute('data-inactive', state.dataset.heroToggleState !== (this.paused ? 'play' : 'pause'));
      }
    }

    onToggle = () => {
      this.paused = !this.paused;
      this.writePaused(this.paused);
      this.renderPaused();
      this.syncFilm();
      if (this.paused) {
        this.stop();
      } else {
        this.start();
      }
    };

    start = () => {
      this.stop();
      if (this.selected || this.paused || !this.interval || this.slides.length < 2) return;
      this.timer = setInterval(() => this.show((this.current + 1) % this.slides.length), this.interval);
    };

    stop = () => {
      clearInterval(this.timer);
      this.timer = null;
    };

    // The merchant editing a slide sees it, and the band does not move on
    // while a block of it is selected, whether or not the pointer is over it.
    onBlockSelect = (event) => {
      const at = this.slides.indexOf(event.target);
      if (at === -1) return;
      this.selected = true;
      this.stop();
      this.show(at);
    };

    onBlockDeselect = (event) => {
      if (!this.slides.includes(event.target)) return;
      this.selected = false;
      this.start();
    };

    onClick = (event) => {
      const button = event.target.closest('[data-hero-index]');
      if (!button || !this.rail.contains(button)) return;
      this.show(Number(button.dataset.heroIndex));
    };

    // The shown slide's film plays while nothing holds it; every other film
    // is paused, so a slide the shopper left is not still running unseen.
    syncFilm() {
      if (document.readyState !== 'complete') {
        if (!this.awaitingLoad) {
          this.awaitingLoad = true;
          window.addEventListener('load', () => this.syncFilm(), { once: true });
        }
        return;
      }
      this.slides.forEach((slide, index) => {
        const film = slide.querySelector('[data-hero-video]');
        if (!film) return;
        if (index === this.current && this.visible && !this.paused) {
          film.play()?.catch(() => {});
        } else {
          film.pause();
        }
      });
    }

    show(next) {
      if (next === this.current) return;

      this.slides[this.current].hidden = true;
      this.indices[this.current]?.removeAttribute('aria-current');

      this.setAttribute('data-hero-moved', '');
      this.slides[next].hidden = false;
      this.indices[next]?.setAttribute('aria-current', 'true');

      const fill = this.indices[next]?.querySelector('.hero__index-fill');
      if (fill) {
        fill.style.animation = 'none';
        void fill.offsetWidth;
        fill.style.animation = '';
      }

      this.current = next;
      this.syncFilm();
    }
  }

  if (!customElements.get('faubourg-hero')) {
    customElements.define('faubourg-hero', FaubourgHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductInfoPanel extends HTMLElement {
    connectedCallback() {
      this.lastY = scrollY;
      addEventListener('scroll', this.onScroll, { passive: true });
      addEventListener('resize', this.onResize, { passive: true });
      if (typeof ResizeObserver !== 'function') return;
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this);
      this.measure();
    }

    disconnectedCallback() {
      removeEventListener('scroll', this.onScroll);
      removeEventListener('resize', this.onResize);
      this.observer?.disconnect();
    }

    // A box found unable to pin is not measured again on every scroll, only
    // once it or the window has changed size.
    onResize = () => {
      this.unpinnable = false;
    };

    measure() {
      this.unpinnable = false;
      this.style.setProperty('--panel-height', `${Math.ceil(this.offsetHeight)}px`);
      if (this.dataset.pin) this.pin(this.dataset.pin);
    }

    onScroll = () => {
      const pin = scrollY > this.lastY ? 'end' : 'start';
      this.lastY = scrollY;
      if (this.unpinnable) return;
      if (pin !== this.dataset.pin) this.pin(pin);
    };

    pin(pin) {
      const { top, bottom } = this.getBoundingClientRect();
      this.style.marginBlock = '';
      const header = document.querySelector('.header--sticky')?.offsetHeight || 0;
      if (getComputedStyle(this).position !== 'sticky' || this.offsetHeight <= innerHeight - header) {
        delete this.dataset.pin;
        this.unpinnable = true;
        return;
      }

      // Read with the margins cleared, so a box that grew while held cannot
      // stretch its column past the gallery.
      const column = this.parentElement;
      const box = column.getBoundingClientRect();
      const style = getComputedStyle(column);
      const start = box.top + parseFloat(style.paddingBlockStart);
      const end = box.bottom - parseFloat(style.paddingBlockEnd);
      const room = Math.max(0, end - start - this.offsetHeight);
      const clamp = (value) => Math.min(room, Math.max(0, value));

      this.dataset.pin = pin;
      this.style.marginBlock = pin === 'end' ? `${clamp(top - start)}px 0px` : `auto ${clamp(end - bottom)}px`;
    }
  }

  if (!customElements.get('product-info-panel')) {
    customElements.define('product-info-panel', ProductInfoPanel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var Drawer = window.Faubourg && window.Faubourg.Drawer;
    if (!Drawer) return;

    // One flag per store, whichever theme install or sign-up it came from.
    // snippets/newsletter-form.liquid writes it under the same spelling.
    var SUBSCRIBED = 'faubourg:popup:subscribed';

    // Closing it is kept with its time, for the merchant's number of days.
    var DISMISSED = 'faubourg:popup:dismissed';
    var DAY = 86400000;

    // Storage can be refused outright; the pop-up then opens on every page
    // rather than throwing.
    function remembered(store, key) {
      try {
        return window[store].getItem(key) !== null;
      } catch (error) {
        return false;
      }
    }

    function remember(store, key, value) {
      try {
        window[store].setItem(key, value || '1');
      } catch (error) {}
    }

    // A time in the future, or one that is not a number, is a clock or a
    // store that cannot be trusted: it counts as no dismissal.
    function dismissedWithin(days) {
      try {
        var at = Number(window.localStorage.getItem(DISMISSED));
        var age = Date.now() - at;
        return at > 0 && age >= 0 && age < days * DAY;
      } catch (error) {
        return false;
      }
    }

    // Versions before 1.2.0 saved a sign-up under the section's id, which
    // changes with each theme install: whatever install it came from, it
    // becomes the store-wide flag. They saved nothing else in localStorage.
    try {
      var store = window.localStorage;
      for (var index = store.length - 1; index >= 0; index -= 1) {
        var key = store.key(index);
        if (key && key.indexOf('faubourg:popup:') === 0 && key !== SUBSCRIBED && key !== DISMISSED) {
          store.setItem(SUBSCRIBED, '1');
          store.removeItem(key);
        }
      }
    } catch (error) {}

    // The editor reports a selection only as it changes, and a changed
    // setting re-renders the section: the new element reads it from here.
    var selected = null;

    class Popup extends Drawer {
      #cue = null;
      #signal = null;
      #tab = null;
      #tabs = null;
      #cameFrom = null;

      connectedCallback() {
        super.connectedCallback();

        var root = this.querySelector('[data-popup]');
        if (!root) return;

        this.sectionId = root.dataset.sectionId;
        this.key = 'faubourg:popup:' + this.sectionId;
        var days = Math.max(Number(root.dataset.dismissDays) || 0, 0);

        // The tab is the pop-up's sibling: the drawer goes inert when closed.
        this.#tab = document.querySelector('[data-popup-tab="' + this.id + '"]');
        this.#tabs = new AbortController();
        var tabs = { signal: this.#tabs.signal };
        if (this.#tab) this.#tab.addEventListener('click', () => this.#reopen(), tabs);
        this.addEventListener('drawer:open', () => {
          this.#cameFrom = null;
          if (this.#tab) this.#tab.hidden = true;
        }, tabs);
        this.addEventListener('drawer:close', (event) => this.#closed(event, root), tabs);

        // Where the shopper came into a corner panel from, which is where the
        // focus goes back to if closing it leaves the focus nowhere.
        this.addEventListener('focusin', (event) => {
          var from = event.relatedTarget;
          if (from instanceof Element && !this.contains(from)) this.#cameFrom = from;
        }, tabs);

        if (window.Shopify && window.Shopify.designMode) {
          if (selected === this.sectionId) this.open({ reason: 'editor' });
          else if (this.#tab) this.#tab.hidden = false;
          return;
        }

        this.addEventListener('drawer:close', (event) => this.#dismiss(event));

        // A sign-up made here answers here: Shopify brings the post back to
        // the page with the form's id as the fragment. The id is ASCII a URL
        // never escapes, so the fragment is read as it stands: decoding it
        // would throw on a stray `%` and leave the pop-up unarmed.
        var answered = window.location.hash ? document.getElementById(window.location.hash.slice(1)) : null;
        if (answered && this.contains(answered)) {
          remember('sessionStorage', this.key);
          this.open({ reason: 'answer', focus: !this.modeless });
          return;
        }

        // Being subscribed silences only a pop-up that asks for a sign-up; the
        // newsletter form records a sign-up from any page. In a section,
        // Liquid reports every theme block's type as '@theme', so whether it
        // asks for one is read from what it rendered.
        if (this.#subscribed(root)) return;

        // Closed before, on this visit or an earlier one: the tab offers it.
        if (this.#tab && (remembered('localStorage', DISMISSED) || remembered('sessionStorage', this.key))) {
          this.#tab.hidden = false;
        }
        if (dismissedWithin(days) || remembered('sessionStorage', this.key)) return;

        var controller = new AbortController();
        this.#signal = controller;

        // Watched from load, so the page's largest paint is never the one
        // under the veil, and from the shopper's answer to the consent banner
        // where there is one.
        this.#consented(controller.signal, () => {
          if (document.readyState === 'complete') {
            this.#watch(root, controller.signal);
          } else {
            window.addEventListener('load', () => this.#watch(root, controller.signal), {
              once: true,
              signal: controller.signal,
            });
          }
        });
      }

      // Being subscribed silences only a pop-up that asks for a sign-up; the
      // newsletter form records a sign-up from any page. In a section, Liquid
      // reports every theme block's type as '@theme', so whether it asks for
      // one is read from what it rendered.
      #subscribed(root) {
        return (
          !!root.querySelector('.newsletter-form') &&
          (root.hasAttribute('data-subscribed') ||
            !!document.querySelector('[data-newsletter-posted]') ||
            remembered('localStorage', SUBSCRIBED))
        );
      }

      // Asked for by the shopper: no cue is still to come on this page.
      #reopen() {
        window.clearTimeout(this.#cue);
        if (this.#signal) this.#signal.abort();
        remember('sessionStorage', this.key);
        this.open({ reason: 'tab', trigger: this.#tab });
      }

      // The tab comes back with every close but the element's removal, unless
      // the shopper has just subscribed. The drawer hands the focus back to
      // its trigger before announcing the close, while the tab is still
      // hidden, and a corner panel the cue opened has no trigger: a focus left
      // nowhere goes to the tab that opened it, to where the shopper came in
      // from, without moving the page, or to the tab.
      #closed(event, root) {
        var reason = event.detail && event.detail.reason;
        if (reason === 'disconnected') return;
        if (this.#tab && ((window.Shopify && window.Shopify.designMode) || !this.#subscribed(root))) {
          this.#tab.hidden = false;
        }
        if (reason === 'drawer-replaced') return;

        var focused = document.activeElement;
        if (focused && focused !== document.body && !this.contains(focused)) return;

        var usable = (node) =>
          node instanceof HTMLElement &&
          node.isConnected &&
          !node.closest('[hidden], [inert]') &&
          node.getClientRects().length > 0;
        var trigger = event.detail.trigger;
        if (usable(trigger)) trigger.focus();
        else if (usable(this.#cameFrom)) this.#cameFrom.focus({ preventScroll: true });
        else if (usable(this.#tab)) this.#tab.focus();
      }

      // Shopify's consent banner is answered, by accepting or refusing,
      // before the pop-up's delay starts. Where the Customer Privacy API is
      // absent, fails to load or has no banner to show, there is nothing to
      // wait for.
      #consented(signal, proceed) {
        var Shopify = window.Shopify;
        if (!Shopify || typeof Shopify.loadFeatures !== 'function') {
          proceed();
          return;
        }

        var done = false;
        var go = () => {
          if (done || signal.aborted) return;
          done = true;
          proceed();
        };

        // Registered first: the event fires only as consent changes.
        document.addEventListener('visitorConsentCollected', go, { once: true, signal: signal });

        // A feature that never answers (blocked, offline) has no banner to
        // wait for either.
        var unanswered = window.setTimeout(go, 10000);
        signal.addEventListener('abort', () => window.clearTimeout(unanswered), { once: true });

        try {
          Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
            window.clearTimeout(unanswered);
            var privacy = window.Shopify && window.Shopify.customerPrivacy;
            var waiting = false;
            try {
              waiting = !error && !!privacy && privacy.shouldShowBanner() === true;
            } catch (failure) {}
            if (!waiting) go();
          });
        } catch (failure) {
          go();
        }
      }

      disconnectedCallback() {
        window.clearTimeout(this.#cue);
        if (this.#signal) this.#signal.abort();
        this.#signal = null;
        if (this.#tabs) this.#tabs.abort();
        this.#tabs = null;
        super.disconnectedCallback();
      }

      // Closed by the shopper, by whatever means; the editor and a removed
      // element are not a refusal.
      #dismiss(event) {
        var reason = event.detail && event.detail.reason;
        if (reason === 'editor' || reason === 'disconnected' || reason === 'drawer-replaced') return;
        remember('localStorage', DISMISSED, String(Date.now()));
      }

      // The merchant's cue. A page with nothing to scroll never reaches a
      // share of itself. Leaving is read from a pointer that hovers: without
      // one (phones, tablets) the pop-up keeps to the delay.
      #watch(root, signal) {
        var trigger = root.dataset.trigger;

        if (trigger === 'scroll') {
          var share = Math.min(Math.max(Number(root.dataset.scrollDepth) || 0, 0), 100) / 100;
          var scrolled = () => {
            var room = document.documentElement.scrollHeight - window.innerHeight;
            if (room > 0 && window.scrollY >= room * share) this.#fire();
          };
          window.addEventListener('scroll', scrolled, { passive: true, signal: signal });
          scrolled();
          return;
        }

        if (trigger === 'leave' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          document.addEventListener(
            'mouseout',
            (event) => {
              if (!event.relatedTarget && event.clientY <= 0) this.#fire();
            },
            { signal: signal }
          );
          return;
        }

        this.#wait(Math.max(Number(root.dataset.delay) || 0, 0) * 1000);
      }

      #wait(delay) {
        window.clearTimeout(this.#cue);
        this.#cue = window.setTimeout(() => {
          if (!this.#fire()) this.#wait(delay);
        }, delay);
      }

      // Not over a drawer the shopper opened, nor under their typing: the
      // delay waits its length again, and scrolling or leaving asks again on
      // the next scroll or the next exit. A corner panel opens without taking
      // the focus, so it has none to give back on closing: the control focused
      // at the cue is not its trigger.
      #fire() {
        if (this.isOpen) return true;

        var focused = document.activeElement;
        var busy =
          document.documentElement.hasAttribute('data-drawer-open') ||
          (focused && focused.matches('input, textarea, select, [contenteditable]'));
        if (busy) return false;

        var modal = !this.modeless;
        if (!this.open({ reason: 'cue', trigger: modal ? focused : null, focus: modal })) return false;
        remember('sessionStorage', this.key);
        if (this.#signal) this.#signal.abort();
        return true;
      }
    }

    if (!customElements.get('faubourg-popup')) {
      customElements.define('faubourg-popup', Popup);
    }

    if (!(window.Shopify && window.Shopify.designMode)) return;

    function popupOf(event) {
      var popup = document.getElementById('popup-' + event.detail.sectionId);
      return popup instanceof Popup ? popup : null;
    }

    function select(event) {
      selected = event.detail.sectionId;
      var popup = popupOf(event);
      if (popup) popup.open({ reason: 'editor' });
    }

    document.addEventListener('shopify:section:select', select);
    document.addEventListener('shopify:block:select', select);
    document.addEventListener('shopify:section:deselect', function (event) {
      if (selected === event.detail.sectionId) selected = null;
      var popup = popupOf(event);
      if (popup) popup.close({ reason: 'editor' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class FaubourgVideo extends HTMLElement {
    connectedCallback() {
      this.poster = this.querySelector('[data-video-poster]');
      this.stage = this.querySelector('[data-video-stage]');
      this.video = this.querySelector('video');
      this.embed = this.querySelector('[data-video-embed]');
      this.playButton = this.querySelector('[data-video-play]');

      // Pressing play hides the button that was pressed, so focus goes with
      // the shopper to the player they started rather than into nothing.
      this.playButton?.addEventListener('click', () => {
        this.play(false);
        (this.video || this.embed?.firstElementChild)?.focus();
      });

      if (this.dataset.autoplay === undefined) return;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduced.matches) return;

      this.play(true);
    }

    play(muted) {
      if (this.embed && !this.embed.firstElementChild) {
        this.embed.appendChild(this.buildEmbed(muted));
      }

      if (this.poster) this.poster.hidden = true;
      if (this.stage) this.stage.hidden = false;

      if (this.video) {
        this.video.muted = muted;
        this.video.play?.().catch(() => {});
      }
    }

    buildEmbed(muted) {
      const iframe = document.createElement('iframe');
      iframe.className = 'video__media';
      iframe.title = this.dataset.title || '';
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;

      const { src, srcMuted } = this.embed.dataset;
      iframe.src = muted ? srcMuted : src;

      return iframe;
    }
  }

  if (!customElements.get('faubourg-video')) {
    customElements.define('faubourg-video', FaubourgVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
